import rootReducer from './rootReducer';
import { configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './slices/apiSlice';
import { setupListeners } from '@reduxjs/toolkit/query'; 
const middlewares = [apiSlice.middleware]; 

const store = configureStore({
	reducer: rootReducer(),
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			immutableCheck: false,
			serializableCheck: false,
		}).concat(middlewares),
	devTools: process.env.NODE_ENV === 'development',
})

store.asyncReducers = {};

export const injectReducer = (key, reducer) => {
	if (store.asyncReducers[key]) {
		return false;
	}
	store.asyncReducers[key] = reducer;
	store.replaceReducer(rootReducer(store.asyncReducers)); 
	return store;
};

setupListeners(store.dispatch);

export default store